import { beginMoveTypeQuestion, moveTypeQuestion, undropTypeQuestion, dropTypeQuestion } from '../../../components/Admin/DragDropHandlers/dragDropTypeQuestion';
import { beginMoveTypeSection, moveTypeSection, undropTypeSection, dropTypeSection } from '../../../components/Admin/DragDropHandlers/dragDropTypeSection';
import { beginMoveTypePage, moveTypePage, undropTypePage, dropTypePage } from '../../../components/Admin/DragDropHandlers/dragDropTypePage';

const dragDropReducers = {
    setDndHoverStyles: (state, action) => {
        state.dndHoverStyles = action.payload;
        return state;
    },
    beginMoveTypeQuestionReducer: (state) => {
        state.dndHoverStyles = beginMoveTypeQuestion(state.applicationQuestions);
        return state;
    },
    moveTypeQuestionReducer: (state, action) => {
        const controlGrid = [
            state.applicationPages,
            state.applicationSections,
            state.applicationGroups,
            state.applicationQuestions,
        ];
        const { dragId, hoverId, dragRef, dragMonitor, domContainerId } = action.payload;
        state.dndHoverStyles = moveTypeQuestion(dragId, hoverId, dragRef, dragMonitor, domContainerId, controlGrid, state.dndHoverStyles);
        return state;
    },
    dropTypeQuestionReducer: (state, action) => {
        const controlGrid = [
            state.applicationPages,
            state.applicationSections,
            state.applicationGroups,
            state.applicationQuestions,
        ];
        const { dragId, hoverId } = action.payload;
        const result = dropTypeQuestion(dragId, hoverId, controlGrid, state.selectedControl);
        state.dndHoverStyles = result.dndHoverStyles;
        state.selectedControl = result.selectedControl;
        state.applicationSections = result.page.newSections;
        state.applicationGroups = result.page.newGroups;
        state.applicationQuestions = result.page.newQuestions;
        state.dragDropErrors = result.dragDropErrors;
        return state;
    },
    undropTypeQuestionReducer: (state) => {
        state.dndHoverStyles = undropTypeQuestion(state.applicationQuestions);
        return state;
    },
    beginMoveTypeSectionReducer: (state) => {
        state.dndHoverStyles = beginMoveTypeSection(state.applicationSections);
        return state;
    },
    moveTypeSectionReducer: (state, action) => {
        const { dragId, hoverId, dragRef, dragMonitor, domContainerId } = action.payload;
        state.dndHoverStyles = moveTypeSection(dragId, hoverId, dragRef, dragMonitor, domContainerId, state.applicationSections, state.dndHoverStyles);
        return state;
    },
    dropTypeSectionReducer: (state, action) => {
        const controlGrid = [
            state.applicationPages,
            state.applicationSections,
            state.applicationGroups,
            state.applicationQuestions,
        ];
        const { dragId, hoverId } = action.payload;
        const result = dropTypeSection(dragId, hoverId, controlGrid, state.selectedControl);
        state.dndHoverStyles = result.dndHoverStyles;
        state.selectedControl = result.selectedControl;
        state.applicationSections = result.page.newSections;
        state.applicationGroups = result.page.newGroups;
        state.applicationQuestions = result.page.newQuestions;
        return state;
    },
    undropTypeSectionReducer: (state) => {
        state.dndHoverStyles = undropTypeSection(state.applicationSections);
        return state;
    },
    beginMoveTypePageReducer: (state) => {
        state.dndHoverStyles = beginMoveTypePage(state.applicationPages);
        return state;
    },
    moveTypePageReducer: (state, action) => {
        const { dragId, hoverId, dragRef, dragMonitor, domContainerId } = action.payload;
        state.dndHoverStyles = moveTypePage(dragId, hoverId, dragRef, dragMonitor, domContainerId, state.applicationPages, state.dndHoverStyles);
        return state;
    },
    clearDragDropErrors: (state) => {
        state.dragDropErrors = [];
        return state;
    },
    dropTypePageReducer: (state, action) => {
        const controlGrid = [
            state.applicationPages,
            state.applicationSections,
            state.applicationGroups,
            state.applicationQuestions,
        ];
        const { dragId, hoverId } = action.payload;
        const result = dropTypePage(dragId, hoverId, controlGrid);
        state.dndHoverStyles = result.dndHoverStyles;
        state.applicationPages = result.updatedGrid.newPages;
        state.applicationSections = result.updatedGrid.newSections;
        state.applicationGroups = result.updatedGrid.newGroups;
        state.applicationQuestions = result.updatedGrid.newQuestions;
        return state;
    },
    undropTypePageReducer: (state) => {
        state.dndHoverStyles = undropTypePage(state.applicationPages);
        return state;
    },
};

export default dragDropReducers;
